/* eslint-disable import/prefer-default-export */
/**
 * @param {any} value
 */
export const toUTagBool = (value) => [(!!value).toString()];
